export default {
  meta: {
    title: '录入集客点',
  }
};
